import React from 'react';
import { useQuery } from '@apollo/client/react';
import { InfoField } from '@components-clean/core/info-field';
import { CM2Dataset } from '@interfaces/central-monitoring';
import { ControlsHubChart } from '@pages-clean/central-monitoring/controls-hub/sections/chart-view/controls-hub-chart';
import { useTranslation } from '@hooks/index';
import { GET_CONTROLS_HUB_CONFIG_PANELS } from '@queries/central-monitoring';
import {
    cm2Panel_OpraQueries,
    getControlsHubConfigPanelsForStudy,
    getControlsHubConfigPanelsForStudyVariables,
} from '@queries/generated/central-monitoring.generated';

type Props = {
    studyRef: string;
    dataset: CM2Dataset;
    chartId: string;
    panelData?: cm2Panel_OpraQueries;
};

export const ControlsHubPopoutChart = ({ studyRef, dataset, chartId, panelData }: Props) => {
    const { data: controlsHubConfigPanels } = useQuery<
        getControlsHubConfigPanelsForStudy,
        getControlsHubConfigPanelsForStudyVariables
    >(GET_CONTROLS_HUB_CONFIG_PANELS, {
        variables: { studyId: studyRef, timestamp: dataset.created },
    });
    const { t } = useTranslation();

    const panels = controlsHubConfigPanels?.getControlsHubConfigPanelsForStudy?.panels?.filter(
        (panel) => panel?.panelRef === chartId,
    );

    if (!panels || panels.length === 0) {
        return (
            <div className="no-panel ">
                <InfoField message={t('cm:controlsHub.panel.noPanel')} type="Info" layout="center" />
            </div>
        );
    }

    return (
        <div className="chart-view k-d-grid k-gap-2">
            {panels.map((panel) => {
                return (
                    <ControlsHubChart
                        key={panel?.panelRef}
                        studyRef={studyRef}
                        dataset={dataset}
                        panelRef={panel?.panelRef}
                        dataViewRef={panel?.dataViewRef}
                        chartTitle={panelData?.cm2Panel?.plotTitle ?? ''}
                    />
                );
            })}
        </div>
    );
};
